import SrcIcon from "@mui/icons-material/Language";
import SRC_TYPES from "../../dictionaries/srcTypes.json";
import BaseTag from "./BaseTag";

const SrcTag = (props) => {
  const label =
    props.value === "__is_null" ? "No-Source" : SRC_TYPES[props.value]?.name;
  return <BaseTag icon={<SrcIcon />} label={label} />;
};

export default SrcTag;
